// extracted by mini-css-extract-plugin
module.exports = {"typography":"Breadcrumbs_typography__2tZSs","separator":"Breadcrumbs_separator__3RB_2"};